module.exports = __webpack_public_path__ + "img/date_retard_48.6d0d2613.jpg";